<template>
  <v-app>
    <v-main>
      <Workshop :work-shop-slide.sync="workShopSlide" />
    </v-main>

    <v-card style="padding: 1%;">
      <v-slider
        @focus="focused = true"
        @blur="focused = false"
        v-if="!$vuetify.breakpoint.xs"
        v-model="workShopSlide"
        :tick-labels="slideLabels"
        :max="slideLabels.length - 1"
        ticks="always"
        step="1"
        tick-size="5"
      ></v-slider>
    </v-card>
    <!-- <v-footer style="background-color: #2196F3">
      <v-row align="center" justify="center">
        <v-btn
          style="margin: 0.5%;"
          href="https://staging.scoutfeedback.com/workshop"
          target="_blank"
          >Give Us Feedback</v-btn
        >
      </v-row>
    </v-footer> -->
  </v-app>
</template>

<script>
import "dwnld-attr-polyfill";
import Workshop from "./components/Workshop";

export default {
  name: "App",
  components: {
    Workshop
  },
  data: () => ({
    workShopSlide: 0,
    slideLabels: [
      "Welcome",
      "Project Information",
      "Irwin Street Traffic Study",
      "Recommended Alignment & Stop Locations",
      "Recommended Plan Views",
      "Typical Cross Sections",
      "Public Comment",
      "Stay Engaged"
    ],
    focused: false
  }),
  created() {
    window.addEventListener("keyup", this.arrowNavigation);
  },
  mounted() {
    const tickLabels = document.getElementsByClassName("v-slider__tick-label");
    const innerHTML = [
      "<p>Welcome</p>",
      "<p>Project Information</p>",
      "<p>Irwin Street Traffic Study</p>",
      "<p>Recommended Alignment <br/> & Stop Locations</p>",
      "<p>Recommended Plan Views</p>",
      "<p>Typical Cross Sections</p>",
      "<p>Public Comment</p>",
      "<p>Stay Engaged</p>"
    ];
    innerHTML.forEach((label, index) => {
      tickLabels[index].innerHTML = label;
    });
  },
  methods: {
    moveSlide(number) {
      this.workShopSlide += number;
    },
    arrowNavigation(event) {
      if (event.keyCode === 37) {
        this.moveSlide(-1);
      }
      if (event.keyCode === 39) {
        this.moveSlide(1);
      }
    }
  },
  watch: {
    workShopSlide(val) {
      if (val > this.slideLabels.length - 1) {
        this.workShopSlide = 0;
      } else if (val < 0) {
        this.workShopSlide = this.slideLabels.length - 1;
      }
    },
    focused(val) {
      if (val) {
        window.removeEventListener("keyup", this.arrowNavigation);
      } else {
        window.addEventListener("keyup", this.arrowNavigation);
      }
    }
  }
};
</script>

<style>
div.v-slider__tick-label p {
  font-size: small !important;
  overflow-wrap: break-word !important;
  word-wrap: break-word !important;
  -ms-hyphens: auto !important;
  -moz-hyphens: auto !important;
  -webkit-hyphens: auto !important;
  hyphens: auto !important;
}
/* .v-slider__tick-label {
  font-size: small !important;
    overflow-wrap: break-word !important;
  word-wrap: break-word !important;
  -ms-hyphens: auto !important;
  -moz-hyphens: auto !important;
  -webkit-hyphens: auto !important;
  hyphens: auto !important;
} */
.centered {
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: center;
}
.slide-content {
  text-align: justify;
  font-family: sans-serif;
  /* font-size: 1rem; */
  font-size: 16px;
}
#header {
  font-size: 25px;
}
#secondary-header {
  font-size: 18px;
}
#footer {
  font-size: 16px;
}
#bottomtext {
  font-size: 16px;
  position: absolute;
  bottom: 0;
}
/* p {
  font-size: 16px !important;
} */
</style>
